/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum ProductFormat {
  LIQUID = "liquid",
  CREAM = "cream",
  GEL = "gel",
  POWDER = "powder",
  SOLID = "solid",
  STICK = "stick",
  AEROSOL = "aerosol",
  FOAM = "foam",
  PASTE = "paste",
  CLAY = "clay",
  BALM = "balm",
  OIL = "oil",
  SERUM = "serum",
  MOUSSE = "mousse",
  WIPES = "wipes",
  TABLET = "tablet",
  PATCH = "patch",
  CAPSULE = "capsule",
  BAR = "bar",
  BUTTER = "butter",
  ROLL_ON = "roll_on",
  OTHER = "other",
}
